

class Utility {

    constructor() {

    }


    getImageUrl(imageType, imageData){
        //console.log('In util');

        if(!imageData||!imageData.data){
        return null;
        }

        const buffer=new Uint8Array(imageData.data);
       
        const blob = new Blob([buffer], { type: imageType });
        //console.log('In util blob',blob);
        const imageUrl = URL.createObjectURL(blob);
        return imageUrl;

   }

    formatDate(dateString) {
       
        if(dateString===null || dateString.length===0){
            return "null"
        }
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      
        const date = new Date(dateString);
        const month = months[date.getMonth()];
        const dayOfMonth = date.getDate();
        const year = date.getFullYear();
        const dayOfWeek = days[date.getDay()];
      
        const hour = date.getHours().toString().padStart(2, '0');
        const minute = date.getMinutes().toString().padStart(2, '0');
        const second = date.getSeconds().toString().padStart(2, '0');
      
        return `${dayOfMonth} ${month} ${year}, ${dayOfWeek} at ${hour}:${minute}:${second}`;
      }

   



   
}

module.exports = Utility;